(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fanplaza-announcement"] && !Shopify.designMode) return;
  try {
    
  class FanPlazaAnnouncementSlider extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.fp-announcement__slide');
      this.currentIndex = 0;
      this.speed = parseInt(this.dataset.speed) || 5;
    }

    connectedCallback() {
      if (this.slides.length <= 1) return;
      this.interval = setInterval(() => this.next(), this.speed * 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    next() {
      this.slides[this.currentIndex].classList.remove('is-active');
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.slides[this.currentIndex].classList.add('is-active');
    }
  }

  customElements.define('fanplaza-announcement-slider', FanPlazaAnnouncementSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fanplaza-product"] && !Shopify.designMode) return;
  try {
    
  class FanPlazaProductPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.product = JSON.parse(document.getElementById('fp-product-json-' + this.sectionId).textContent);
      this.variantInventory = JSON.parse(document.getElementById('fp-variant-inventory-' + this.sectionId)?.textContent || '{}');
      this.variantInput = document.getElementById('fp-variant-id-' + this.sectionId);
      this.atcBtn = document.getElementById('fp-atc-' + this.sectionId);
      this.floatingAtc = document.getElementById('fp-floating-atc-' + this.sectionId);
      this.floatingAtcBtn = document.getElementById('fp-floating-atc-btn-' + this.sectionId);
      this.priceEl = document.getElementById('fp-price-' + this.sectionId);

      this.initSwiper();
      this.initVariantSelector();
      this.initColorHover();
      this.initFloatingAtc();
      this.initFloatingAtcSubmit();
      this.initAjaxCart();
      this.initSizeGuideDrawer();
      this.initDetailPanel();
      this.initZoom();
      this.initLowStock();
      this.initInstallments();
      this.initDeliveryEstimate();
      this.initBackInStock();
      this.initAccordion();
    }

    initSwiper() {
      const el = document.getElementById('fp-gallery-' + this.sectionId);
      if (!el) return;

      const waitForSwiper = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(waitForSwiper, 100);
          return;
        }

        this.swiper = new Swiper(el, {
          loop: true,
          speed: 400,
          autoHeight: window.matchMedia('(max-width: 1023px)').matches,
          navigation: {
            prevEl: '#fp-prev-' + this.sectionId,
            nextEl: '#fp-next-' + this.sectionId,
          },
          on: {
            slideChange: (swiper) => {
              const pageEl = document.getElementById('fp-page-current-' + this.sectionId);
              if (pageEl) pageEl.textContent = swiper.realIndex + 1;

              // Update thumbnail active state
              const thumbs = document.querySelectorAll('#fp-thumbs-' + this.sectionId + ' .fp-pdp__thumb');
              thumbs.forEach((t, i) => {
                t.classList.toggle('fp-pdp__thumb--active', i === swiper.realIndex);
              });
            }
          }
        });

        // Thumbnail click → slide to image
        const thumbContainer = document.getElementById('fp-thumbs-' + this.sectionId);
        if (thumbContainer) {
          thumbContainer.querySelectorAll('.fp-pdp__thumb').forEach((thumb) => {
            thumb.addEventListener('click', () => {
              const idx = parseInt(thumb.dataset.thumbIndex, 10);
              this.swiper.slideToLoop(idx);
            });
          });
        }
      };

      waitForSwiper();
    }

    initColorHover() {
      const swatches = this.querySelectorAll('.fp-pdp__color-swatch');
      const nameEl = document.getElementById('fp-swatch-color-name');
      const container = this.querySelector('.fp-pdp__color-swatches');
      if (!nameEl || !container || swatches.length === 0) return;

      const defaultColor = container.dataset.defaultColor || '';

      swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', () => {
          const colorName = swatch.dataset.colorName || '';
          nameEl.textContent = colorName;
        });
        swatch.addEventListener('mouseleave', () => {
          nameEl.textContent = defaultColor;
        });
      });

      /* Fade-out hint: remove mask when scrolled to end */
      const checkScrollEnd = () => {
        const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 2;
        container.classList.toggle('is-scrolled-end', atEnd);
      };
      container.addEventListener('scroll', checkScrollEnd, { passive: true });
      checkScrollEnd();
    }

    initVariantSelector() {
      const buttons = this.querySelectorAll('[data-option-value]');
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;

          const optionName = btn.dataset.optionName;
          const optionValue = btn.dataset.optionValue;

          /* Update selected state */
          const siblings = this.querySelectorAll(`[data-option-name="${optionName}"]`);
          siblings.forEach(s => s.classList.remove('is-selected'));
          btn.classList.add('is-selected');

          /* Update color name display */
          const colorNameEl = document.getElementById('fp-color-name-' + this.sectionId);
          if (colorNameEl && (optionName.toLowerCase() === 'color' || optionName.toLowerCase() === 'colour' || optionName.toLowerCase() === 'farbe')) {
            colorNameEl.textContent = optionValue;
          }

          /* Find matching variant */
          this.updateVariant();
        });
      });
    }

    updateVariant() {
      const selectedOptions = [];
      this.product.options.forEach(optionName => {
        const selected = this.querySelector(`[data-option-name="${optionName}"].is-selected`);
        if (selected) selectedOptions.push(selected.dataset.optionValue);
      });

      const variant = this.product.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );

      if (!variant) return;

      /* Update hidden input */
      this.variantInput.value = variant.id;

      /* Update price */
      if (this.priceEl) {
        const money = (cents) => {
          const formatter = new Intl.NumberFormat(Shopify.locale || 'de-DE', {
            style: 'currency',
            currency: Shopify.currency?.active || 'EUR'
          });
          return formatter.format(cents / 100);
        };

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.priceEl.innerHTML = `<span class="fp-pdp__price--sale">${money(variant.price)}</span><s class="fp-pdp__price--compare">${money(variant.compare_at_price)}</s>`;
        } else {
          this.priceEl.textContent = money(variant.price);
        }
      }

      /* Update ATC button */
      const formattedPrice = new Intl.NumberFormat(Shopify.locale || 'de-DE', { style: 'currency', currency: Shopify.currency?.active || 'EUR' }).format(variant.price / 100);
      const floatingPrice = document.getElementById('fp-floating-price-' + this.sectionId);

      if (variant.available) {
        this.atcBtn.disabled = false;
        this.atcBtn.textContent = window.variantStrings?.addToCart || 'Add to Cart';
        if (this.floatingAtcBtn) {
          this.floatingAtcBtn.disabled = false;
          this.floatingAtcBtn.textContent = window.variantStrings?.addToCart || 'Add to Cart';
        }
      } else {
        this.atcBtn.disabled = true;
        this.atcBtn.textContent = window.variantStrings?.soldOut || 'Sold Out';
        if (this.floatingAtcBtn) {
          this.floatingAtcBtn.disabled = true;
          this.floatingAtcBtn.textContent = window.variantStrings?.soldOut || 'Sold Out';
        }
      }

      /* Update floating price */
      if (floatingPrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const comparePrice = new Intl.NumberFormat(Shopify.locale || 'de-DE', { style: 'currency', currency: Shopify.currency?.active || 'EUR' }).format(variant.compare_at_price / 100);
          floatingPrice.innerHTML = '<span class="fp-pdp__price--sale">' + formattedPrice + '</span> <s class="fp-pdp__price--compare">' + comparePrice + '</s>';
        } else {
          floatingPrice.textContent = formattedPrice;
        }
      }

      /* Update floating variant label */
      const floatingVariant = document.getElementById('fp-floating-variant-' + this.sectionId);
      if (floatingVariant && variant.title !== 'Default Title') {
        floatingVariant.textContent = variant.title;
      }

      /* Update CRO elements */
      this.updateLowStock(variant);
      this.updateInstallments(variant);
      this.updateBackInStock(variant);

      /* Update URL */
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    initFloatingAtc() {
      if (!this.floatingAtc || !this.atcBtn) return;

      let hasScrolled = false;

      window.addEventListener('scroll', () => { hasScrolled = true; }, { once: true, passive: true });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.floatingAtc.classList.remove('is-visible');
            } else if (hasScrolled) {
              this.floatingAtc.classList.add('is-visible');
            }
          });
        },
        { threshold: 0 }
      );

      observer.observe(this.atcBtn);
    }

    initFloatingAtcSubmit() {
      if (!this.floatingAtcBtn) return;

      this.floatingAtcBtn.addEventListener('click', () => {
        const form = document.getElementById('fp-product-form-' + this.sectionId);
        if (form) form.requestSubmit();
      });
    }

    initAjaxCart() {
      const form = document.getElementById('fp-product-form-' + this.sectionId);
      if (!form) return;

      form.addEventListener('submit', (e) => {
        e.preventDefault();

        const variantId = this.variantInput.value;
        if (!variantId) return;

        /* Disable button during request */
        if (this.atcBtn) {
          this.atcBtn.disabled = true;
          this.atcBtn.textContent = 'Adding...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        })
        .then(r => {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(() => {
          /* Fire event so cart drawer refreshes + opens */
          document.dispatchEvent(new CustomEvent('fanplaza:cart:updated'));

          /* Re-enable button */
          if (this.atcBtn) {
            this.atcBtn.disabled = false;
            this.atcBtn.textContent = window.variantStrings?.addToCart || 'Add to Cart';
          }
        })
        .catch(() => {
          if (this.atcBtn) {
            this.atcBtn.disabled = false;
            this.atcBtn.textContent = window.variantStrings?.addToCart || 'Add to Cart';
          }
        });
      });
    }

    initDetailPanel() {
      const panel = document.getElementById('fp-detail-panel-' + this.sectionId);
      const closeBtn = document.getElementById('fp-panel-close-' + this.sectionId);
      if (!panel) return;

      const descContent = document.getElementById('fp-content-description-' + this.sectionId);
      const shipContent = document.getElementById('fp-content-shipping-' + this.sectionId);
      let activePanel = null;

      const allTabs = document.querySelectorAll('#fp-tab-description-' + this.sectionId + ', #fp-tab-shipping-' + this.sectionId + ', [data-panel-toggle][data-panel="description"], [data-panel-toggle][data-panel="shipping"]');

      const open = (type) => {
        /* Show correct content */
        if (descContent) descContent.style.display = type === 'description' ? 'block' : 'none';
        if (shipContent) shipContent.style.display = type === 'shipping' ? 'block' : 'none';

        /* Update tab states */
        allTabs.forEach(t => {
          t.classList.toggle('is-active', t.dataset.panel === type);
        });

        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        /* overflow managed via CSS body classes */
        activePanel = type;
      };

      const close = () => {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        /* overflow managed via CSS body classes */
        allTabs.forEach(t => t.classList.remove('is-active'));
        activePanel = null;
      };

      /* Tab clicks — both sticky bar and panel bar */
      allTabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const type = tab.dataset.panel;
          if (activePanel === type) {
            close();
          } else {
            open(type);
          }
        });
      });

      closeBtn.addEventListener('click', close);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
      });
    }

    initSizeGuideDrawer() {
      const trigger = document.getElementById('fp-size-guide-trigger-' + this.sectionId);
      const drawer = document.getElementById('fp-size-guide-drawer-' + this.sectionId);
      if (!trigger || !drawer) return;

      const overlay = drawer.querySelector('.fp-size-guide-drawer__overlay');
      const closeBtn = drawer.querySelector('.fp-size-guide-drawer__close');

      const open = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        /* overflow managed via CSS body classes */
        closeBtn.focus();
      };

      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        /* overflow managed via CSS body classes */
        trigger.focus();
      };

      trigger.addEventListener('click', open);
      closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', close);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    }

    /* ── Low Stock Indicator ── */
    initLowStock() {
      this.lowStockEl = document.getElementById('fp-low-stock-' + this.sectionId);
      if (!this.lowStockEl) return;
      /* Set initial state from current variant */
      const currentVariant = this.product.variants.find(v => String(v.id) === String(this.variantInput.value));
      if (currentVariant) this.updateLowStock(currentVariant);
    }

    updateLowStock(variant) {
      if (!this.lowStockEl) return;
      const threshold = parseInt(this.lowStockEl.dataset.threshold, 10) || 5;
      const qty = this.variantInventory[String(variant.id)];
      if (qty !== undefined && qty > 0 && qty <= threshold) {
        this.lowStockEl.textContent = 'Only ' + qty + ' left';
        this.lowStockEl.style.display = '';
      } else {
        this.lowStockEl.style.display = 'none';
      }
    }

    /* ── Installment Messaging ── */
    initInstallments() {
      this.installmentsEl = document.getElementById('fp-installments-' + this.sectionId);
      if (!this.installmentsEl) return;
      this.installmentsAmountEl = this.installmentsEl.querySelector('.fp-pdp__installments-amount');
      this.installmentCount = parseInt(this.installmentsEl.closest('[data-shopify-editor-block]')?.querySelector('[data-installment-count]')?.value, 10) || 4;
      /* Parse count from the text content as fallback */
      const match = this.installmentsEl.textContent.match(/(\d+)\s+interest-free/);
      if (match) this.installmentCount = parseInt(match[1], 10);
    }

    updateInstallments(variant) {
      if (!this.installmentsAmountEl) return;
      const count = this.installmentCount || 4;
      const amount = variant.price / 100 / count;
      const formatter = new Intl.NumberFormat(Shopify.locale || 'de-DE', {
        style: 'currency',
        currency: Shopify.currency?.active || 'EUR'
      });
      this.installmentsAmountEl.textContent = formatter.format(amount);
    }

    /* ── Delivery Estimate ── */
    initDeliveryEstimate() {
      this.deliveryEl = document.getElementById('fp-delivery-' + this.sectionId);
      if (!this.deliveryEl) return;

      this.deliveryCutoff = parseInt(this.deliveryEl.dataset.cutoff, 10) || 14;
      this.deliveryMinDays = parseInt(this.deliveryEl.dataset.minDays, 10) || 2;
      this.deliveryMaxDays = parseInt(this.deliveryEl.dataset.maxDays, 10) || 4;

      this.renderDeliveryEstimate();
      this._deliveryInterval = setInterval(() => this.renderDeliveryEstimate(), 60000);
    }

    renderDeliveryEstimate() {
      if (!this.deliveryEl) return;

      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const cutoff = this.deliveryCutoff;

      let shipsDate;
      if (hours < cutoff) {
        /* Before cutoff — calculate countdown */
        const remainH = cutoff - hours - 1;
        const remainM = 60 - minutes;
        const adjustedH = remainM === 60 ? remainH + 1 : remainH;
        const adjustedM = remainM === 60 ? 0 : remainM;
        const countdownText = adjustedH > 0 ? adjustedH + 'h ' + adjustedM + 'm' : adjustedM + 'm';
        shipsDate = new Date(now);
        /* Ships today */
        const deliveryMin = this.addBusinessDays(shipsDate, this.deliveryMinDays);
        const deliveryMax = this.addBusinessDays(shipsDate, this.deliveryMaxDays);
        this.deliveryEl.innerHTML = 'Order within <strong>' + countdownText + '</strong> — estimated delivery: <strong>' + this.formatDateRange(deliveryMin, deliveryMax) + '</strong>';
      } else {
        /* After cutoff — ships next business day */
        shipsDate = this.addBusinessDays(now, 1);
        const deliveryMin = this.addBusinessDays(shipsDate, this.deliveryMinDays);
        const deliveryMax = this.addBusinessDays(shipsDate, this.deliveryMaxDays);
        this.deliveryEl.innerHTML = 'Order now — estimated delivery: <strong>' + this.formatDateRange(deliveryMin, deliveryMax) + '</strong>';
      }
    }

    addBusinessDays(startDate, days) {
      const result = new Date(startDate);
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        const dow = result.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return result;
    }

    formatDateRange(dateMin, dateMax) {
      const opts = { month: 'short', day: 'numeric' };
      const locale = Shopify.locale || 'en';
      const minStr = dateMin.toLocaleDateString(locale, opts);
      const maxStr = dateMax.toLocaleDateString(locale, opts);
      if (minStr === maxStr) return minStr;
      return minStr + ' – ' + maxStr;
    }

    /* ── Back in Stock Notification (Drawer + Klaviyo) ── */
    initBackInStock() {
      this.bisEl = document.getElementById('fp-bis-' + this.sectionId);
      this.bisDrawer = document.getElementById('fp-bis-drawer-' + this.sectionId);
      this.bisForm = document.getElementById('fp-bis-form-' + this.sectionId);
      this.bisVariantInput = document.getElementById('fp-bis-variant-' + this.sectionId);
      this.bisVariantTitleInput = document.getElementById('fp-bis-variant-title-' + this.sectionId);
      this.bisSuccess = document.getElementById('fp-bis-success-' + this.sectionId);
      this.bisSizeLabel = document.getElementById('fp-bis-size-' + this.sectionId);
      this.bisDrawerVariant = document.getElementById('fp-bis-drawer-variant-' + this.sectionId);
      this.bisTrigger = document.getElementById('fp-bis-trigger-' + this.sectionId);
      if (!this.bisEl || !this.bisDrawer) return;

      /* Move drawer to body root so page blur doesn't affect it */
      this.bisOverlay = this.bisDrawer.querySelector('.fp-bis-drawer__overlay');
      document.body.appendChild(this.bisDrawer);

      /* Make sold-out size buttons clickable for back-in-stock */
      this.querySelectorAll('.fp-pdp__size-btn.is-soldout').forEach(btn => {
        btn.addEventListener('click', () => {
          const optionName = btn.dataset.optionName;
          const optionValue = btn.dataset.optionValue;

          /* Update selected state for that option group */
          this.querySelectorAll('[data-option-name="' + optionName + '"]').forEach(s => s.classList.remove('is-selected'));
          btn.classList.add('is-selected');

          /* Find the sold-out variant */
          const selectedOptions = [];
          this.product.options.forEach(oName => {
            const selected = this.querySelector('[data-option-name="' + oName + '"].is-selected');
            if (selected) selectedOptions.push(selected.dataset.optionValue);
          });

          const variant = this.product.variants.find(v =>
            v.options.every((opt, i) => opt === selectedOptions[i])
          );

          if (variant && !variant.available) {
            this.showBackInStock(variant);
          } else if (variant && variant.available) {
            this.hideBackInStock();
            this.updateVariant();
          }
        });
      });

      /* Set initial state */
      const currentVariant = this.product.variants.find(v => String(v.id) === String(this.variantInput.value));
      if (currentVariant) {
        this.updateBackInStock(currentVariant);
      } else {
        const firstVariant = this.product.variants[0];
        if (firstVariant && !firstVariant.available) {
          this.showBackInStock(firstVariant);
        }
      }

      /* Trigger opens drawer */
      if (this.bisTrigger) {
        this.bisTrigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.openBisDrawer();
        });
      }

      /* Close: X button */
      this.bisDrawer.querySelector('.fp-bis-drawer__close').addEventListener('click', () => this.closeBisDrawer());

      /* Close: click/tap overlay (area outside panel) */
      if (this.bisOverlay) {
        this.bisOverlay.addEventListener('click', () => this.closeBisDrawer());
        this.bisOverlay.addEventListener('touchend', (e) => {
          e.preventDefault();
          this.closeBisDrawer();
        });
        this.bisOverlay.addEventListener('touchmove', (e) => { e.preventDefault(); }, { passive: false });
      }

      /* Close on Escape */
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.bisDrawer.classList.contains('is-open')) {
          this.closeBisDrawer();
        }
      });

      /* Form submit → Klaviyo Back in Stock API */
      if (this.bisForm) {
        this.bisForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const email = this.bisForm.querySelector('input[type="email"]').value;
          const variantId = this.bisVariantInput.value;
          if (!email || !variantId) return;

          const submitBtn = this.bisForm.querySelector('.fp-bis-drawer__submit');
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Sending...';
          }

          /* Klaviyo Back in Stock subscription via client API */
          this.subscribeBisKlaviyo(email, variantId).then(() => {
            this.bisForm.style.display = 'none';
            this.bisSuccess.style.display = '';
          }).catch(() => {
            /* Show success anyway — email was likely captured */
            this.bisForm.style.display = 'none';
            this.bisSuccess.style.display = '';
          });
        });
      }
    }

    subscribeBisKlaviyo(email, variantId) {
      /* Use Klaviyo's onsite client API if available */
      if (typeof window._klOnsite !== 'undefined' || typeof window.klaviyo !== 'undefined') {
        const kl = window.klaviyo || window._klOnsite;
        if (kl && typeof kl.push === 'function') {
          kl.push(['identify', { email: email }]);
          kl.push(['track', 'Back in Stock Subscribed', {
            ProductTitle: this.bisForm.querySelector('[name="product_title"]').value,
            ProductHandle: this.bisForm.querySelector('[name="product_handle"]').value,
            VariantId: variantId,
            VariantTitle: this.bisVariantTitleInput.value,
            ProductId: this.bisForm.querySelector('[name="product_id"]').value
          }]);
          return Promise.resolve();
        }
      }

      /* Fallback: Klaviyo Back in Stock API v2 (requires public API key) */
      const klaviyoKey = window.klaviyoKey || document.querySelector('[data-klaviyo-key]')?.dataset?.klaviyoKey;
      if (klaviyoKey) {
        return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + klaviyoKey, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email
                    }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: '$shopify:::$default:::' + variantId
                  }
                }
              }
            }
          })
        });
      }

      /* No Klaviyo — log to console for debugging */
      console.log('BIS Subscription (no Klaviyo):', { email, variantId, product: this.bisForm.querySelector('[name="product_handle"]').value });
      return Promise.resolve();
    }

    openBisDrawer() {
      this.bisDrawer.classList.add('is-open');
      this.bisDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fp-bis-is-open');
      /* overflow managed via CSS body classes */
      /* Reset form state */
      if (this.bisForm) {
        this.bisForm.style.display = '';
        this.bisSuccess.style.display = 'none';
        const submitBtn = this.bisForm.querySelector('.fp-bis-drawer__submit');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Notify Me';
        }
      }
      /* Focus email input */
      setTimeout(() => {
        const input = this.bisDrawer.querySelector('input[type="email"]');
        if (input) input.focus();
      }, 300);
    }

    closeBisDrawer() {
      this.bisDrawer.classList.remove('is-open');
      this.bisDrawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fp-bis-is-open');
      /* overflow managed via CSS body classes */
    }

    showBackInStock(variant) {
      if (!this.bisEl) return;
      this.bisVariantInput.value = variant.id;
      this.bisVariantTitleInput.value = variant.title;
      /* Hide "Default Title" — single-variant products have no meaningful variant name */
      const displayTitle = variant.title === 'Default Title' ? '' : variant.title;
      /* Update inline text: "XL sold out? Get notified..." */
      if (this.bisSizeLabel) this.bisSizeLabel.textContent = displayTitle;
      /* Update drawer variant info */
      if (this.bisDrawerVariant) this.bisDrawerVariant.textContent = displayTitle;
      this.bisEl.style.display = '';

      /* Update ATC to sold out */
      this.atcBtn.disabled = true;
      this.atcBtn.textContent = window.variantStrings?.soldOut || 'Sold Out';
      if (this.floatingAtcBtn) {
        this.floatingAtcBtn.disabled = true;
        this.floatingAtcBtn.textContent = window.variantStrings?.soldOut || 'Sold Out';
      }
    }

    hideBackInStock() {
      if (!this.bisEl) return;
      this.bisEl.style.display = 'none';
    }

    updateBackInStock(variant) {
      if (!this.bisEl) return;
      if (!variant.available) {
        this.showBackInStock(variant);
      } else {
        this.hideBackInStock();
      }
    }

    initAccordion() {
      const accordions = this.querySelectorAll('.fp-pdp__accordion-item');
      accordions.forEach(details => {
        const summary = details.querySelector('.fp-pdp__accordion-trigger');
        const content = details.querySelector('.fp-pdp__accordion-content');
        if (!summary || !content) return;

        summary.addEventListener('click', e => {
          e.preventDefault();

          if (details.open) {
            // Animate close
            content.style.height = content.scrollHeight + 'px';
            content.offsetHeight;
            requestAnimationFrame(() => {
              content.style.height = '0';
              content.style.opacity = '0';
            });
            setTimeout(() => {
              details.removeAttribute('open');
              content.style.height = '';
              content.style.opacity = '';
            }, 300);
          } else {
            // Animate open
            details.setAttribute('open', '');
            const h = content.scrollHeight;
            content.style.height = '0';
            content.style.opacity = '0';
            content.offsetHeight;
            requestAnimationFrame(() => {
              content.style.height = h + 'px';
              content.style.opacity = '1';
            });
            setTimeout(() => { content.style.height = 'auto'; }, 300);
          }
        });
      });
    }

    initZoom() {
      const zoomBtn = document.getElementById('fp-zoom-' + this.sectionId);
      if (!zoomBtn) return;

      zoomBtn.addEventListener('click', () => {
        /* Build all images HTML */
        let imagesHtml = '';
        this.product.media.forEach(media => {
          if (media.media_type === 'image') {
            const src = media.src ? media.src.replace(/width=\d+/, 'width=1600') : media.preview_image.src;
            imagesHtml += '<img src="' + src + '" alt="' + (media.alt || '') + '" class="fp-pdp__lightbox-img" width="' + media.width + '" height="' + media.height + '">';
          }
        });

        const lightbox = document.createElement('div');
        lightbox.className = 'fp-pdp__lightbox';
        lightbox.innerHTML =
          '<button class="fp-pdp__lightbox-close" aria-label="Close">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
          '<div class="fp-pdp__lightbox-scroll">' + imagesHtml + '</div>';

        document.body.appendChild(lightbox);
        /* overflow managed via CSS body classes */
        requestAnimationFrame(() => lightbox.classList.add('is-open'));

        const closeLightbox = () => {
          lightbox.classList.remove('is-open');
          setTimeout(() => {
            lightbox.remove();
            /* overflow managed via CSS body classes */
          }, 300);
        };

        lightbox.querySelector('.fp-pdp__lightbox-close').addEventListener('click', closeLightbox);
        document.addEventListener('keydown', function handler(e) {
          if (e.key === 'Escape') {
            closeLightbox();
            document.removeEventListener('keydown', handler);
          }
        });
      });
    }
  }

  if (!customElements.get('fanplaza-product-page')) {
    customElements.define('fanplaza-product-page', FanPlazaProductPage);
  }

  } catch(e) { console.error(e); }
})();
})();
